import { FeatureFlags } from "constants/feature-flags";
import { CurrentUserState } from "slices/currentUser/currentUser.reducer";

export const assertFeatureFlagIsEnabled = (
  currentUser: CurrentUserState,
  featureName: keyof typeof FeatureFlags,
): boolean => {
  return !!currentUser?.features?.[featureName];
};
